import * as React from "react";
import Drawer from "@mui/material/Drawer";
import "./styles.scss";
import { useEffect, useState } from "react";
import { toggleDrawer } from "../../utils/utils";
import NewButton from "../common/NewButton/NewButton";
import { CloseOutlined } from "@mui/icons-material";
import {
  Stack,
  Box,
  Typography,
  IconButton,
  FormControlLabel,
  FormGroup,
  styled,
  Switch,
  alpha,
} from "@mui/material";
import NewAccount from "./NewAccount";
import CustomSnackbar from "../common/Snackbar/CustomSnackbar";
import { AccountType } from "../../types/genericType";
import { resetSelectedAccount } from "../../redux/features/accountSlice";
import { useDispatch } from "react-redux";
import { primary } from "../../theme/palette";
import { DropdownOptions } from "../common/Dropdown/Dropdown";

const ColoredSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: primary,
    "&:hover": {
      backgroundColor: alpha("##606ADD", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: primary,
  },
}));

type NewAccountDrawerProps = {
  getAccountsData: Function;
  selectedAccount: AccountType;
  updateSelectedAccount: Function;
  openEditDrawer: boolean;
  setOpenEditDrawer: Function;
  clientOptions: DropdownOptions[];
  clientView: boolean;
};

const NewAccountDrawer = (props: NewAccountDrawerProps) => {
  const {
    getAccountsData,
    openEditDrawer,
    setOpenEditDrawer,
    selectedAccount,
    clientOptions,
    clientView,
    updateSelectedAccount
  } = props;
  const [open, setOpen] = useState(false);
  const [editFlow, setEditFlow] = useState(false);
  const [onSuccess, setOnSuccess] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [currentAccountStatus, setCurrentAccountStatus] = useState(false);
  const [updatedAccountStatus, setUpdatedAccountStatus] = useState(false);
  const dispatch = useDispatch();

  const handleDrawerOpen = toggleDrawer<React.KeyboardEvent | React.MouseEvent>(
    true,
    setOpen
  );
  const handleDrawerClose = () => {
    setEditFlow(false);
    setOpen(false);
    setOpenEditDrawer(false);
  };

  useEffect(() => {
    let initialActiveState = false;
    if (selectedAccount) {
      if (!selectedAccount.endDate) {
        initialActiveState = true;
      } else {
        const endDate = new Date(selectedAccount.endDate);
        const currentDate = new Date();
        if (endDate > currentDate) {
          initialActiveState = true;
        }
      }
    }
    setCurrentAccountStatus(initialActiveState);
    setUpdatedAccountStatus(initialActiveState);
  }, [selectedAccount]);

  useEffect(() => {
    if (openEditDrawer) {
      setEditFlow(true);
      setOpen(openEditDrawer);
    }
  }, [openEditDrawer]);

  useEffect(() => {
    if (!editFlow) {
      dispatch(resetSelectedAccount());
    }
  }, [editFlow]);

  const drawerComp = (
    <Stack>
      <Box className="drawer-header" role="presentation">
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          fontWeight={700}
        >
          {clientView ? "View Account" : (editFlow ? "Edit Account" : "New Account")}
        </Typography>
        {editFlow && (
          <FormGroup>
            <FormControlLabel
              control={
                <ColoredSwitch
                  checked={updatedAccountStatus}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setUpdatedAccountStatus(event.target.checked);
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                  disabled={clientView}
                />
              }
              label={updatedAccountStatus ? "Open" : "Close"}
            />
          </FormGroup>
        )}
        <IconButton
          aria-label="toggle password visibility"
          onClick={handleDrawerClose}
          size="large"
        >
          <CloseOutlined />
        </IconButton>
      </Box>
      <NewAccount
        getAccountsData={getAccountsData}
        setDrawerOpen={setOpen}
        clientOptions={clientOptions}
        setOnTxnSuccess={setOnSuccess}
        setSnackbarMsg={setSnackbarMsg}
        editFlow={editFlow}
        setEditFlow={setEditFlow}
        selectedAccount={selectedAccount}
        currentAccountStatus={currentAccountStatus}
        updatedAccountStatus={updatedAccountStatus}
        handleDrawerClose={handleDrawerClose}
        clientView={clientView}
        updateSelectedAccount={updateSelectedAccount}
      />
    </Stack>
  );

  return (
    <div className="transaction-drawer">
      <React.Fragment>
        {!clientView && (
          <NewButton
            title="NEW ACCOUNT"
            handleBtnClick={handleDrawerOpen}
            type="contained"
          />
        )}
        <Drawer
          anchor="right"
          variant="temporary"
          onClose={handleDrawerClose}
          open={open}
          sx={{
            display: { xs: "none", sm: "block" },
            "&.MuiDrawer-root .MuiDrawer-paper": {
              marginTop: "65px",
              width: "436px",
            },
          }}
        >
          {drawerComp}
        </Drawer>
        <CustomSnackbar
          open={onSuccess}
          message={snackbarMsg}
          setOpen={setOnSuccess}
        />
      </React.Fragment>
    </div>
  );
};

export default NewAccountDrawer;
